export default "__VITE_PUBLIC_ASSET__8961820d__"